import logo_all from "../images/logos_alle.jpg";

export default function Supporters() {
    return (
        <div className="page-class">
            <h1>Förderer</h1>
            <p className="mb-5">poetica westfalia wird ermöglicht mit freundlicher Unterstützung von:</p>
            <img src={logo_all} alt="LWL Logo" className='img-fluid supporter-logo mb-5' /><br />
        </div>

    );
}